import React from 'react'
import { Redirect, RouteComponentProps } from '@reach/router'

type NotFound = React.FC<RouteComponentProps>
export const NotFound: NotFound = () => {
  return <Redirect noThrow to="/products" replace />
}
